import React from 'react'
import { GoTopContainer } from './style'

//* Images
import goTopImg from '../../../../static/steam-img/go_top_button.svg'
import WrapperImage from '../wrapperImage'

const goTop = () => {
  const handleGoTop = () => {
    window.scroll({ top: 0, behavior: 'smooth' })
  }

  return (
    <GoTopContainer>
      <div className="GlobalGoTop__content">
        <div className="GlobalGoTop__imgWrapper" onClick={handleGoTop}>
          <WrapperImage src={goTopImg} alt="Go Top icon" threshold={650} />
        </div>
      </div>
    </GoTopContainer>
  )
}

export default goTop
